import axios from "axios";
import { globalNavigate } from "./NavigationService";
import SnackbarUtils from "./SnackbarUtils";
import { triggerLogout } from "../context/AuthHelper";
import TokenStorage from "./TokenStorage";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8080";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  timeout: 60000,
  headers: { "Content-Type": "application/json" },
});

let isNetworkSnackbarOpen = false;
const redirectTo = (path, clearTokens = false) => {
  if (clearTokens) triggerLogout();
  try {
    globalNavigate(path);
  } catch {
    window.location.href = path;
  }
};

// Sin X-Tenant-Id: los usuarios core no pertenecen a ninguna empresa.
axiosInstance.interceptors.request.use((config) => {
  const token = TokenStorage.getToken("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.headers["Accept-Language"] = localStorage.getItem("language") || "es";
  return config;
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config: originalRequest, response } = error;

    if (originalRequest?.url?.includes("/session/login")) {
      return Promise.reject(error);
    }

    if (!response) {
      if (!isNetworkSnackbarOpen) {
        isNetworkSnackbarOpen = true;
        SnackbarUtils.error("Sin conexión con el servidor. Verificá tu conexión a internet.", {
          onClose: () => { isNetworkSnackbarOpen = false; },
          autoHideDuration: 6000,
        });
      }
      return Promise.reject(error);
    }

    // El backend no renueva tokens de cuentas core (el access token dura 60 minutos y
    // /session/refresh_token exige refreshToken y empresaId): un 401 es sesión vencida.
    if (response.status === 401) {
      redirectTo("/login", true);
      return Promise.reject(error);
    }

    if (response.status === 403 && !originalRequest?.skipGlobalErrorRedirect) {
      redirectTo("/permission-denied");
    }

    if (response.status === 500 && !originalRequest?.skipGlobalErrorRedirect) {
      redirectTo("/internal-server-error");
    }

    if (response.status === 400 && response.data?.error_message && !originalRequest?.skipSnackbar) {
      SnackbarUtils.error(response.data.error_message.split(":")[0].trim());
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
